import './inc/font-awesome.js'
import './inc/analytics.js'
import './inc/iubenda.js'
import './inc/home-video.js'
import './inc/scrolltop.js'
import './inc/carousel.js'
import './inc/subscribe.js'

$(document).ready(function() {
  
  $(function(){
    $('img').Lazy({
      visibleOnly: true,
    });
  });

  $(function() {
    return $(".carousel").on("slide.bs.carousel", function(e) {
      const lazy = $(e.relatedTarget).find("img[data-src]");
      lazy.attr("src", lazy.data('src'));
      lazy.removeAttr("data-src");
    });
  });

  $.expr[':'].external = function(obj){
    return !obj.href.match(/^mailto\:/)
      && (obj.hostname != location.hostname)
      && !obj.href.match(/^javascript\:/)
      && !obj.href.match(/^$/)
  };
  
  $('a:external').attr('target', '_blank');
  $('a:external').attr('rel', 'noopener');
  
  document.addEventListener( 'wpcf7mailsent', function (event) {
    $('.modal').modal('hide');
    setTimeout(() => {
      alert( "Il tuo messaggio è stato inviato correttamente. Grazie." );
    }, 1000);
  }, false );

});




// WEBPACK FOOTER //
// ./js/index.js